import * as constants from "../../../config/constants";
import { PERSONAL_LOANS_DEFAULT_PATH } from "../../../config/site/thecreditreview";
import {
	getFilter,
	getInitialFilteringConfiguration,
	getVertical,
} from "../../selectors";

export const setInitialFilteringState = () => (dispatch, getState) => {
	const state = getState();
	const filter = getFilter(state);
	const filteringInformation = getInitialFilteringConfiguration(state);

	if (!filter) return;
	if (!filteringInformation) return;
	if (!(filter in filteringInformation)) return;

	const vertical = getVertical(state);
	const tcrPersonalLoansVertical =
		constants.SITE === constants.TCR_DOMAIN &&
		vertical === PERSONAL_LOANS_DEFAULT_PATH;

	const filterConfigs = filteringInformation[filter];
	const payload = filterConfigs.reduce(
		(acc, filterConfig) => {
			acc[filterConfig.filteringKey] = filterConfig.filterValue;

			return acc;
		},
		{
			[constants.FILTERING_PARAMETERS_COUNT]: tcrPersonalLoansVertical
				? filterConfigs.length - 1
				: filterConfigs.length,
		},
	);

	dispatch({
		type: constants.INITIAL_FILTERING_PARAMETERS_SET,
		payload,
	});
};

export const setFilteringState = (filteringParameters) => (dispatch) => {
	dispatch({ type: constants.SHOW_FILTERING_TRANSITION });

	const hideTransitionAndApplyFilters = () => {
		dispatch({
			type: constants.FILTERING_PARAMETERS_SET,
			payload: filteringParameters,
		});
		dispatch({ type: constants.HIDE_FILTERING_TRANSITION });
	};

	setTimeout(() => {
		hideTransitionAndApplyFilters();
	}, constants.FILTERING_TRANSITION_DURATION);
};

export const resetFilteringState = () => (dispatch) => {
	dispatch({ type: constants.SHOW_FILTERING_TRANSITION });

	const hideTransitionAndApplyFilters = () => {
		dispatch({ type: constants.FILTERING_PARAMETERS_RESET });
		dispatch({ type: constants.HIDE_FILTERING_TRANSITION });
	};

	setTimeout(() => {
		hideTransitionAndApplyFilters();
	}, constants.FILTERING_TRANSITION_DURATION);
};

export const setModalFilteringState =
	(filteringParameters, vertical) => (dispatch) => {
		dispatch({ type: constants.SHOW_FILTERING_TRANSITION });

		const hideTransitionAndApplyFilters = () => {
			dispatch({
				type: constants.MODAL_FILTERING_PARAMETERS_SET,
				payload: {
					filteringParameters: filteringParameters,
					vertical: vertical,
				},
			});
			dispatch({ type: constants.HIDE_FILTERING_TRANSITION });
		};

		setTimeout(() => {
			hideTransitionAndApplyFilters();
		}, constants.FILTERING_TRANSITION_DURATION);
	};

export const setFilteringStateWithoutTransition =
	(filteringParameters) => (dispatch) => {
		dispatch({
			type: constants.FILTERING_PARAMETERS_SET,
			payload: filteringParameters,
		});
	};

export const deleteFilteringProperty = (key) => (dispatch) => {
	dispatch({ type: constants.DELETE_FILTERING_PROPERTY, payload: key });
};
